export class NotFoundError extends Error {
  constructor(messageKey?: string) {
    super(messageKey);
    this.name = 'NotFoundError';
  }
}
